import React from 'react';
import { TrackingProp } from 'react-tracking';
import { StyledH1, StyledP } from 'components';
import styled from 'styled-components';
import { SEO } from 'components/SEO';
import GlobalLayout from 'components/Layouts/GlobalLayout';
import { analyticsWrapper } from 'analytics/itly/analyticsWrapper';
import { useTrackPageViewed } from 'analytics/itly/hooks';
import { useGoogleReCaptcha } from 'features/google-recaptcha';
import { useTikTok } from 'hooks/useTikTok';
import { AULink } from 'components/AULink';

const NotFoundLinksWrapper = styled.div`
  display: flex;
  flex-direction: column;

  > button {
    background: none;
    border: none;
    display: flex;
    padding: 0;
    cursor: pointer;
    color: #000;

    &:hover {
      color: #959595;
    }
  }

  > a,
  button {
    font-size: 0.75rem;
    letter-spacing: 1px;
    text-decoration: underline !important;
    text-transform: uppercase;
    margin: 0.5rem 0;
  }
`;

const ContentWrapper = styled.div`
  margin: 3rem 5rem;
  @media screen and (max-width: 768px) {
    margin: 3rem 1rem;
  }
`;

function NotFoundPage({ tracking }: { tracking: TrackingProp }) {
  useTrackPageViewed(tracking, 'Error', '404: Not Found');
  useGoogleReCaptcha({ pageType: 'Error', pageName: '404: Not Found', action: 'error' });
  useTikTok({ event: 'PageView' });

  return (
    <GlobalLayout>
      <ContentWrapper>
        <SEO title="404: Not found" />
        <StyledH1 secondary>Oops, Our Bad…</StyledH1>
        <StyledP secondary>The page you’re looking for was not found.</StyledP>
        <br />
        <StyledP secondary>Make sure the URL you requested is spelled correctly.</StyledP>
        <StyledP secondary>
          If you clicked a link within the site, the link is outdated and we are working to get this fixed.
        </StyledP>
        <br />
        <StyledP secondary>What's next?</StyledP>
        <StyledP secondary>
          Try using the search bar in the top right corner to find a product, or visit one of the pages below:
        </StyledP>
        <br />
        <NotFoundLinksWrapper>
          <button onClick={() => typeof window !== 'undefined' && window.history.back()}>Previous Page</button>
          <AULink id="homepage" path="/" linkToGatsby>Homepage</AULink>
          <AULink id="my-account" path="/customer/account" linkToGatsby>My Account</AULink>
        </NotFoundLinksWrapper>
      </ContentWrapper>
    </GlobalLayout>
  );
}

export default analyticsWrapper(NotFoundPage);
